module.exports = __webpack_public_path__ + "img/rep-noel.92660f18.jpg";